import getPageTitle from '@/utils/get-page-title'

const DEFAULT_KEYWORDS =
  'AI后端开发,Bmob,后端云,Serverless,云函数,云数据库,大模型,MCP,AI建表,BaaS,AI驱动,软件后端开发平台,小程序后端,移动开发'

const DEFAULT_DESCRIPTION =
  'Bmob 是 AI 驱动的软件后端开发平台，提供 AI 建表、大模型 Hub、MCP 服务、Serverless 云函数与云数据库，帮助开发者用自然语言快速构建应用后端。'

const DEFAULT_OG_TYPE = 'website'

export const PASSWORD_RESET_META = {
  title: '重置密码',
  brandless: true,
  description: '重置您的应用账号密码。',
  keywords: '密码重置,账号安全',
  ogTitle: '重置密码'
}

function upsertMeta(attr, key, content) {
  if (content == null || content === '') return
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

/**
 * Apply route meta to document title and head meta tags.
 * Falls back to site defaults when description/keywords are omitted.
 */
export default function applyPageMeta(meta = {}) {
  const title = meta.title || ''
  const description = meta.description != null ? meta.description : (meta.brandless ? PASSWORD_RESET_META.description : DEFAULT_DESCRIPTION)
  const keywords = meta.keywords != null ? meta.keywords : (meta.brandless ? PASSWORD_RESET_META.keywords : DEFAULT_KEYWORDS)
  const ogTitle = meta.ogTitle != null ? meta.ogTitle : (title || (meta.brandless ? '重置密码' : 'Bmob后端云'))
  const ogDescription = meta.ogDescription != null ? meta.ogDescription : description

  document.title = meta.brandless ? (title || '重置密码') : getPageTitle(title)
  let icon = document.querySelector('link[rel="icon"]')
  if (!icon) {
    icon = document.createElement('link')
    icon.setAttribute('rel', 'icon')
    document.head.appendChild(icon)
  }
  icon.setAttribute('href', meta.brandless ? '/password-reset.svg' : '/favicon.ico')
  icon.setAttribute('type', meta.brandless ? 'image/svg+xml' : 'image/x-icon')
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'keywords', keywords)
  upsertMeta('property', 'og:title', ogTitle)
  upsertMeta('property', 'og:description', ogDescription)
  upsertMeta('property', 'og:type', DEFAULT_OG_TYPE)
}

export { DEFAULT_DESCRIPTION, DEFAULT_KEYWORDS }
